import React, { FC } from 'react'
import Carousel from 'components/SA/Carousel/v2'
import styles from './Homepage.module.scss'
import { useSelector } from 'react-redux'
import { getLargeCarouselItems } from '../selectors'
import SALink from 'components/SALink'
import { capitalizeString } from 'lib/helpers'
import useQA from 'hooks/useQA'
import { displayEllipticalString } from 'apps/public/profile/artistProfile/helpers'

const MAX_LENGTH = 65

const FeaturedCollections: FC = () => {
  const collections = useSelector(getLargeCarouselItems)
  const { testId } = useQA()

  return (
    <div className={styles.featuredCollections} {...testId('featured-collections')}>
      <Carousel title='Featured Collections'>
        {collections.map((item, index) => (
          <div key={index} className={styles.carouselItemWrapper}>
            <SALink href={item.collectionUrl} title={capitalizeString(item.title)}>
              <div key={index} className={styles.carouselItem} {...testId('carousel-item')}>
                <img src={item.jpgLarge} className={styles.carouselImage} />
                <p className={styles.title} {...testId('title')}>
                  {displayEllipticalString(capitalizeString(item.title), MAX_LENGTH)}
                </p>
              </div>
            </SALink>
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export default FeaturedCollections
